import type { Settings } from "../types";
import "./section-header.css";

export function SectionHeader({title,language,onBack,className=""}:{title:string;language:Settings["language"];onBack?:()=>void;className?:string}) {
  return <header className={`precision-section-header ${className}`}>
    <button type="button" onClick={onBack} aria-label={{pt:"Voltar",de:"Zurück",en:"Back",fr:"Retour",it:"Indietro"}[language]}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden><path d="m15 5-7 7 7 7"/></svg>
    </button>
    <h1>{title}</h1><span aria-hidden/>
  </header>;
}
